import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AiAutocompletePluginState } from '../types/types';

export const aiAutocompletePluginKey = new PluginKey<AiAutocompletePluginState>(
	'aiAutocompletePlugin',
);
